import { Box, Card, CardHeader, Flex, VStack } from '@chakra-ui/react'
import { useAppModals, useAuth } from '@hb/react'
import { BigGreenButton, PregnancyCareCard, useMyAssessments } from '@hb/react-web'
import { GYN_ENABLED } from '@hb/shared'
import { useMemo } from 'react'
import { GynCareCard } from '../GYN/GynCareCard'
import { PatientDataForm } from '../Patients/PatientDataForm'

const SignInActions = () => {
  const { open: openSignIn } = useAppModals(s => s.signIn)
  return (
    <Flex gap={5} p={3} mt={5}>
      <BigGreenButton onClick={() => openSignIn()}>Patient Login</BigGreenButton>
      <a style={{ opacity: 1 }} href="https://providers.hamiltonbilling.com">
        <BigGreenButton>Provider Login</BigGreenButton>
      </a>
    </Flex>
  )
}

const SignedInActions = () => {
  const {
    user: { user },
  } = useMyAssessments()
  const { phone, dob, fname, lname } = user ?? {}
  const patientDataComplete = useMemo(
    () => phone && dob && fname && lname,
    [phone, dob, fname, lname],
  )
  if (!patientDataComplete) {
    return <PatientDataForm />
  }
  return (
    <VStack pt={4} w="100%" spacing={3}>
      <Card w="100%">
        <CardHeader py={3} textAlign="center" fontSize="xl">
          Hi {fname}! Why are you here today?
        </CardHeader>
      </Card>
      <Flex flexDir={['column', 'column', 'row']} gap={3} w="100%">
        {GYN_ENABLED ? (
          <Box flex={1}>
            <GynCareCard patient={user} />
          </Box>
        ) : null}
        <Box flex={1}>
          <PregnancyCareCard />
        </Box>
      </Flex>
    </VStack>
  )
}

export const HomeActions = () => {
  const authUser = useAuth(s => s.authUser)

  if (authUser) return <SignedInActions />
  return <SignInActions />
}
